var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"previewVideo"},[_c('video',{staticClass:"video",attrs:{"controls":"","autoplay":"","name":"media"}},[_c('source',{attrs:{"src":"https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_1920_18MG.mp4","type":"video/mp4"}})])])
}]

export { render, staticRenderFns }